import { useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import FormLabel from "@mui/material/FormLabel";
import { useEffect } from "react";


const CssFormLabel = styled(FormLabel)({
  color: "black"

});

export function CommonLabel(props) {
  const { name, value, tagName, prefix, display } = props;
  const { setFieldValue, values } = useFormikContext();

  // Helpers to decode entities and strip HTML
  const decodeEntities = (s) =>
    s
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  const stripTags = (s) => s.replace(/<[^>]*>/g, "");
  const sanitizeValue = (v) =>
    typeof v === "string" ? stripTags(decodeEntities(v)).trim() : v;

  useEffect(() => {
    if (value) {
      setTimeout(function () {
        setFieldValue([name], sanitizeValue(value));
      }, 300);
    }
  }, []);

  const handleChange = (e) => {
    const { value: v } = e.target;
    setFieldValue([name], sanitizeValue(v));
  };

  const rawValue = value;
  const decodedValue =
    typeof rawValue === "string" ? decodeEntities(rawValue) : rawValue;
  const isHtmlValue =
    typeof decodedValue === "string" && /<\/?[a-z][\s\S]*>/i.test(decodedValue);
  const plainValue = sanitizeValue(rawValue);

  return (
    <>
      <div className={display === false ? "display-none" : ""}>
        <div className="flex-container">
          <div className="control-bottom-border">
            <label className="font-css" id="myLabel">
              {props.label}
            </label>
          </div>

          <div className="control-bottom-border">
            <FormControl variant="standard">
              <CssFormLabel
                aria-labelledby="myLabel"
                id={tagName}
                type="label"
                name={name}
                key={name}
                tagname={tagName}
                fieldname={name}
                prefix={prefix}
                defaultValue={plainValue}
                placeholder=""
                onChange={handleChange}
                value={plainValue}
              >
                {isHtmlValue ? (
                  <span dangerouslySetInnerHTML={{ __html: decodedValue }} />
                ) : (
                  decodedValue
                )}
              </CssFormLabel>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
}
